/**
 * Get a value from the current page's session storage
 * @param  {[type]} key          [description]
 * @param  {[type]} defaultValue [description]
 * @return {[type]}              [description]
 */
module.exports.get = (key, defaultValue = null) => {

    //
    const value = window.sessionStorage.getItem(key);

    //
    if (!value || value === 'null') {
        return null;
    }

    //
    try {
        return JSON.parse(value);
    } catch (e) {
        console.log(e);
    }

    //
    return defaultValue;

};

/**
 * Set a value from the current page's session storage
 * @param  {[type]} key   [description]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
module.exports.set = (key, value = null) => {

    //
    if (value === undefined) {
        value = null;
    } else {
        value = JSON.stringify(value);
    }

    //
    try {
        window.sessionStorage.setItem(key, value);
    } catch (e) {
        console.log(e);
    }

};

/**
 * Remove a value from the current page's session storage
 * @param  {[type]} key [description]
 * @return {[type]}     [description]
 */
module.exports.remove = (key) => {
    window.localStorage.removeItem(key);
};
